module.exports = __webpack_public_path__ + "static/img/example-web.8416e7d9.png";